import { inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { NotifyService } from '../../ui/notify';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  private notifyService = inject(NotifyService)

  copyText(text: string): Observable<void> {
    try {
      if (navigator.clipboard) {
        return new Observable<void>(observer => {
          navigator.clipboard.writeText(text).then(() => {
            observer.next()
            observer.complete()
            this.notifyService.createFromText('Скопировано')
          }).catch(err => {
            observer.error(err)
          })
        })
      } else {
        const textarea = document.createElement('textarea')
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.notifyService.createFromText('Скопировано')
        } catch (e) {
          return throwError(() => e)
        }
        finally {
          document.body.removeChild(textarea)
        }
      }
    }
    catch (e) {
      return throwError(() => e)
    }
    return of(undefined)
  }

}
